<div class="route-status">
  <div class="route-status__grooming">
    <img [src]="statusIconUrl()" width="32" height="32" />
    @if (machineIconUrl(); as machineIconUrl) {
      <img
        class="route-status__machine"
        [src]="machineIconUrl"
        width="24"
        height="24"
        [alt]="maintainerTypeTranslationKey() ?? '' | translate"
        [dvTooltip]="maintainerTypeTranslationKey() ?? '' | translate"
      />
    }
    <div class="route-status__info">
      <div>{{ 'General.LastGroomed' | translate }}</div>
      <div class="route-status__info--time">{{ lastGroomedTimeText() }}</div>
    </div>
  </div>
  <div class="route-status__length">
    @if (length(); as length) {
      <dv-divider direction="vertical"></dv-divider>
      <div class="route-status__details">
        <div>{{ 'General.TotalLength' | translate }}</div>
        <div class="route-status__details--km">
          {{ length + ' km' }}
        </div>
      </div>
    }
  </div>
</div>

@if (!customerId() || customerId() === -1) {
  <div class="no-customer">
    <span class="no-customer__text">
      {{ 'Map.NoRouteNetworkCustomerText' | translate }}
    </span>
    <span class="no-customer__link" onclick="window.location.assign('/info')">
      {{ 'Map.NoRouteNetworkCustomerLink' | translate }}
    </span>
  </div>
}
